<template>
  <div>
    <!-- Espaçador para o navbar -->
    <div class="navbar-spacer"></div>

    <div class="overview-area ptb-100 bg-f9f9f9">
      <div class="container">
        <div class="overview-box">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 overview-image">
              <img src="../../assets/images/overview/overview1.png" data-aos="fade-up" alt="overview">
            </div>
            <div class="col-lg-6 col-md-12 overview-content">
              <span class="sub-title">Fábrica de Software</span>
              <h2>Desenvolvimento de projetos sob medida</h2>
              <ul class="overview-list">
                <li data-aos="fade-up" data-aos-duration="1200">
                  <span>
                      <i class="flaticon-draw-check-mark"></i>
                      Sistemas Web e Portais Corporativos
                  </span>
                </li>
                <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                  <span>
                      <i class="flaticon-draw-check-mark"></i>
                      ERP e Sistemas de Gestão
                  </span>
                </li>
                <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                  <span>
                      <i class="flaticon-draw-check-mark"></i>
                      APIs e Integrações
                  </span>
                </li>
                <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="300">
                  <span>
                      <i class="flaticon-draw-check-mark"></i>
                      Produtos SaaS Verticais
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="overview-box">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 overview-content">
              <span class="sub-title">Soluções em Nuvem</span>
              <h2>Infraestrutura moderna e escalável</h2>
              <ul class="overview-list">
                <li data-aos="fade-up" data-aos-duration="1200">
                  <span>
                      <i class="flaticon-draw-check-mark"></i>
                      Arquitetura em Nuvem (AWS/Azure)
                  </span>
                </li>
                <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                  <span>
                      <i class="flaticon-draw-check-mark"></i>
                      Aplicações Mobile (iOS/Android)
                  </span>
                </li>
                <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                  <span>
                      <i class="flaticon-draw-check-mark"></i>
                      DevOps e Automação
                  </span>
                </li>
                <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="300">
                  <span>
                      <i class="flaticon-draw-check-mark"></i>
                      Monitoramento e Analytics
                  </span>
                </li>
              </ul>
            </div>
            <div class="col-lg-6 col-md-12 overview-image">
              <img src="../../assets/images/overview/overview2.png" data-aos="fade-up" alt="overview">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Services',
  mounted() {
    // Força o navbar a ficar sticky em páginas internas
    window.scrollTo(0, 0);
    window.dispatchEvent(new Event('scroll'));
  }
}
</script>

<style scoped>
/* Espaçador para o navbar não sobrepor o conteúdo */
.navbar-spacer {
  height: 90px;
}

@media (max-width: 991px) {
  .navbar-spacer {
    height: 70px;
  }
}
</style>